import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useSelectListState = () =>
  useStore(store => store.selectList.state)
